//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbDynamicSwiperSlide from '../../../smart-container/dynamic-swiper-slide'
import { mapGetters } from 'vuex'

export default {
  name: 'rb-blurred-slider',
  components: {
    RbDynamicSwiperSlide,
  },
  data() {
    return {
      defaultConfig: {
        spaceBetween: 32,
        slidesPerView: 1.3,
        centeredSlides: true,
      },
      currentSlideBackground: '',
      currentSlideTheme: '',
    }
  },
  computed: {
    ...mapGetters(['translation']),
    swiperSlides() {
      return this.$slots.default.filter((slot) => !!slot.tag)
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.reInitSwiper()
    })
  },
  methods: {
    reInitSwiper() {
      if (this.$refs.swiperRef?.swiper) {
        this.$refs.swiperRef.swiper.destroy()
        this.$nextTick(() => {
          this.$refs.swiperRef.$options.propsData.config.allowTouchMove = true
          this.$refs.swiperRef._setup()
          this.$nextTick(() => {
            const firstSlide = this.$refs.swiperRef.swiper?.slides[0]
            this.currentSlideBackground = firstSlide
              ?.querySelector('.rb-banner__image img')
              ?.getAttribute('data-src')
            this.currentSlideTheme = firstSlide?.children[0]?.getAttribute('theme')
            if (!this.currentSlideBackground) {
              this.swiperSlidesCurrentIndex(0)
            }
          })
        })
      }
    },
    swiperSlidesCurrentIndex(index) {
      const indexSlide = this.$refs.swiperRef.swiper.activeIndex
      const currentSlide = this.$refs.swiperRef.swiper.slides[indexSlide + index]
      this.currentSlideBackground = currentSlide.querySelector('.rb-banner__image img').src
      this.currentSlideTheme = currentSlide?.children[0]?.getAttribute('theme')
    },
  },
}
